export default __webpack_public_path__ + "static/media/send-ic.0690547b.svg";